import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountPasswordChangeComponent } from './account-password-change.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [AccountPasswordChangeComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    TranslateModule
  ],
  exports: [AccountPasswordChangeComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class AccountPasswordChangeModule {}
